import { FC } from 'react';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash';
import cn from 'classnames';
import {
  createBemBlockBuilder,
  GetBemBlocksWith,
  ShowMore,
} from '@ebsco-ui/ebsco-ui';

import { ContributorDto, SEARCH_OPTION, ShowMoreButton } from '@app/components';
import { useQueryParams } from '@app/hooks';
import { generateRouteParams } from '@app/utils';
import { ROUTE } from '@app/constants';

const maxAmountToDisplay = 3;

const cnBemRecordSummary = createBemBlockBuilder(['recordSummary']);

export interface ContributorsListProps {
  cnBemModalOrPlacement: GetBemBlocksWith;
  shouldDisplayNameAsText: boolean;
  list?: ContributorDto[];
  contributorsAmount: number;
}

export const ContributorsList: FC<ContributorsListProps> = ({
  cnBemModalOrPlacement,
  list = [],
  shouldDisplayNameAsText,
  contributorsAmount,
}) => {
  const queryParams = useQueryParams();

  if (isEmpty(list)) {
    return null;
  }

  return (
    <ShowMore
      limit={maxAmountToDisplay}
      className={cnBemRecordSummary('__showMore')}
    >
      <ul className={cnBemRecordSummary('__contributorsList')}>
        <ShowMore.Items>
          {list.map(({ name, contributorTypeName, contributorTypeText }) => (
            <li key={name}>
              {!shouldDisplayNameAsText ? (
                <Link
                  to={generateRouteParams({
                    pathname: ROUTE.search,
                    query: {
                      ...queryParams,
                      option: SEARCH_OPTION.author,
                      query: name,
                    },
                  })}
                  className={cn(
                    'underlinedLink',
                    cnBemModalOrPlacement('__link')
                  )}
                >
                  {name}
                </Link>
              ) : (
                name
              )}
              {(contributorTypeName || contributorTypeText) &&
                `, ${contributorTypeName || contributorTypeText}`}
            </li>
          ))}
        </ShowMore.Items>
      </ul>
      <ShowMoreButton
        showMoreLimit={maxAmountToDisplay}
        dataLength={contributorsAmount}
      />
    </ShowMore>
  );
};
